import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { Entity } from '@/store/modules/entities/entitiesTypes'

interface EntityComposable {
  saveSelectedEntityName: (context?: string) => void
  saveSelectedIdEntity: (params: { idEntity: number; context: string }) => void
  createEntity: (params: { entityType: number | string; idEntity: number; context: string }) => void
  getEntity: (context?: string) => Entity
  entityName: string
}

export default function useEntity({ entityName }: { entityName: string }): EntityComposable {
  const endpointModule = ModuleNamespaces.ENDPOINT
  const entityModule = ModuleNamespaces.ENTITIES

  // ACTIONS
  const saveSelectedEntityName = (context: string = entityName): void => {
    store.dispatch(`${entityModule}/saveSelectedEntityName`, context)
  }

  const saveSelectedIdEntity = ({ idEntity, context = entityName }: { idEntity: number; context: string }): void => {
    store.dispatch(`${endpointModule}/saveSelectedIdEntity`, { idEntity, context })
  }

  const createEntity = ({
    entityType,
    idEntity,
    context
  }: {
    entityType: number | string
    idEntity: number
    context: string
  }): void => {
    store.dispatch(`${entityModule}/createEntity`, { entityType, idEntity, context })
  }

  // GETTERS
  const getEntity = (context: string = entityName): Entity => {
    return store.getters[`${entityModule}/getEntity`](context)
  }

  return {
    saveSelectedEntityName,
    saveSelectedIdEntity,
    createEntity,
    getEntity,
    entityName
  }
}
